import { render, staticRenderFns } from "./StartBtn.vue?vue&type=template&id=6a97ceef&scoped=true&"
import script from "./StartBtn.vue?vue&type=script&lang=js&"
export * from "./StartBtn.vue?vue&type=script&lang=js&"
import style0 from "./StartBtn.vue?vue&type=style&index=0&id=6a97ceef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a97ceef",
  null
  
)

export default component.exports